"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveInputs = exports.loadInputs = void 0;
const model_1 = require("./model");
const KEY = "ahti-surplus-calculator/inputs";
/**
 * Kept in the viewer's own browser and never sent anywhere. It exists so a
 * returning user does not retype their prices, which is the slowest part of
 * the form on a phone.
 */
const loadInputs = () => {
    const fallback = {
        fossil: model_1.DEFAULT_FOSSIL,
        raw: model_1.DEFAULT_RAW_INPUTS,
    };
    try {
        const stored = window.localStorage.getItem(KEY);
        if (!stored)
            return fallback;
        const parsed = JSON.parse(stored);
        const pick = (field) => typeof parsed[field] === "string" ? parsed[field] : undefined;
        return {
            fossil: parsed.fossil === "hfo" ||
                parsed.fossil === "lfo" ||
                parsed.fossil === "mgo"
                ? parsed.fossil
                : model_1.DEFAULT_FOSSIL,
            raw: {
                ...model_1.DEFAULT_RAW_INPUTS,
                tons: pick("tons") ?? model_1.DEFAULT_RAW_INPUTS.tons,
                ciBio: pick("ciBio") ?? model_1.DEFAULT_RAW_INPUTS.ciBio,
                priceFossil: pick("priceFossil") ?? model_1.DEFAULT_RAW_INPUTS.priceFossil,
                priceBio: pick("priceBio") ?? model_1.DEFAULT_RAW_INPUTS.priceBio,
                poolPriceEur: pick("poolPriceEur") ?? model_1.DEFAULT_RAW_INPUTS.poolPriceEur,
            },
        };
    }
    catch {
        // Private windows and blocked site data throw on access rather than
        // returning null, so the defaults have to survive that.
        return fallback;
    }
};
exports.loadInputs = loadInputs;
const saveInputs = (fossil, raw) => {
    try {
        const { eua: _eua, fx: _fx, ...rest } = raw;
        window.localStorage.setItem(KEY, JSON.stringify({ fossil, ...rest }));
    }
    catch {
        // Nothing to do — persistence is a convenience, not a requirement.
    }
};
exports.saveInputs = saveInputs;
